module.exports = __webpack_public_path__ + "static/media/Heneritta Bullard Wardrobes.5ee169dc.jpg";